import React, { useEffect, useState } from "react";
import { DatePicker, Calendar, Input, Modal } from "antd";
import { FullscreenExitOutlined, FullscreenOutlined } from "@ant-design/icons";
import Reviews from "./Reviews";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedRpmPatient } from "../../../../../Redux/actions/rpmActions";
import AllergyDetails from "../../../ConsultationNotes/VitalTabs/MedicalHistory/AllergyDetails";
import PastMedicalHistory from "../../../ConsultationNotes/VitalTabs/MedicalHistory/PastMedicalHistory";
import SurgicalHistory from "../../../ConsultationNotes/VitalTabs/MedicalHistory/SurgicalHistory";
import FamilyHistory from "../../../ConsultationNotes/VitalTabs/MedicalHistory/FamilyHistory";
import SocialHistory from "../../../ConsultationNotes/VitalTabs/MedicalHistory/SocialHistory";
import Medication from "../../../ConsultationNotes/VitalTabs/MedicalHistory/Medication";
import ChronicCondition from "../../../ConsultationNotes/VitalTabs/MedicalHistory/ChronicCondition";
import Vaccination from "../../../ConsultationNotes/VitalTabs/MedicalHistory/Vaccinations";
import ActivityCalender from "./ActivityCalender";
function Summary() {
  const [isFullScreen, setIsFullScreen] = useState(false);
  const { selectedRpmPatient } = useSelector((state) => state.rpm);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!selectedRpmPatient) {
      const rpmPatientJson = sessionStorage.getItem("rpmPatient");
      const rpmPatientObject = rpmPatientJson
        ? JSON.parse(rpmPatientJson)
        : null;
      if (rpmPatientObject) dispatch(setSelectedRpmPatient(rpmPatientObject));
    }
  }, []);

  const toggleFullScreen = () => {
    setIsFullScreen(!isFullScreen);
  };

  const colSpan = isFullScreen ? 8 : 12;
  const colSpan8 = isFullScreen ? 8 : 24;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    // Handle save logic here (you can update a review list, etc.)
    setIsModalOpen(false);
    setTitle("");
    setDescription("");
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <div
      className={`grid  ${isFullScreen ? "fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[500] mt-60" : ""}`}
    >
      <div className="bg-white rounded-lg pt-0 p-1 overflow-hidden w-full">
        <div className="flex justify-between items-center px-4 py-3">
          <div className="text-gray-800 text-2xl font-semibold">Summary</div>
          <div className="flex items-center space-x-4">
            <DatePicker picker="month" />
            {isFullScreen ? (
              <FullscreenExitOutlined
                onClick={toggleFullScreen}
                style={{ fontSize: "26px", color: "#08c" }}
              />
            ) : (
              <FullscreenOutlined
                onClick={toggleFullScreen}
                style={{ fontSize: "26px", color: "#08c" }}
              />
            )}
          </div>
        </div>

        {/* Cards and Review */}
        <div className="bg-gray-100 p-4 rounded-lg h-[900px] overflow-y-scroll scrollWidth">
          <div className="grid grid-cols-2">
            <AllergyDetails
              permissionData={{ medicalHistory: "Y" }}
              selectedPatient={selectedRpmPatient}
            />
            <PastMedicalHistory
              permissionData={{ medicalHistory: "Y" }}
              selectedPatient={selectedRpmPatient}
            />
            <SurgicalHistory
              permissionData={{ medicalHistory: "Y" }}
              selectedPatient={selectedRpmPatient}
            />
            <FamilyHistory
              permissionData={{ medicalHistory: "Y" }}
              selectedPatient={selectedRpmPatient}
            />
            <SocialHistory
              permissionData={{ medicalHistory: "Y" }}
              selectedPatient={selectedRpmPatient}
            />
            <Medication
              permissionData={{ medicalHistory: "Y" }}
              selectedPatient={selectedRpmPatient}
            />
            <ChronicCondition
              permissionData={{ medicalHistory: "Y" }}
              selectedPatient={selectedRpmPatient}
            />
            <Vaccination
              permissionData={{ medicalHistory: "Y" }}
              selectedPatient={selectedRpmPatient}
            />
          </div>

          {/* Reviews list component */}
          <Reviews />

          <div className="bg-white rounded-lg p-4 shadow mt-5">
            <div className=" text-cyan-700 text-xl font-medium">Activities</div>
            <div className="p-5">
              <ActivityCalender />
            </div>
          </div>
        </div>
      </div>
      <Modal
        title="Add Review"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={
          <span>
            <div className="flex justify-end gap-3">
              <button className="border rounded-md px-3 py-1.5 text-brand-primaryColor">
                Cancel
              </button>
              <button className="border rounded-md px-3 py-1.5 text-white bg-brand-primaryColor">
                Submit
              </button>
            </div>
          </span>
        }
      >
        <div className="space-y-4 mt-2 rounded-lg p-2">
          <div className="space-y-1">
            <label className="block text-sm font-medium text-gray-700">
              Title
            </label>
            <Input
              placeholder="Enter title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </div>
          <div className="space-y-1">
            <label className="block text-sm font-medium text-gray-700">
              Description
            </label>
            <Input.TextArea
              rows={4}
              placeholder="Enter description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default Summary;
